import * as React from "react";
import { DocumentPreview } from "../framework/documentPreview";
import { t } from "i18next";
import { ToolTitle } from "../framework/toolTitle";

export interface IReportViewPreviewProp {
    file: string;
    fileName: string;
    fileMimeType: string;
    thumbnails: string[];
    thumbnailIndex: number;
}

export class ReportViewPreview extends React.Component<IReportViewPreviewProp, {}> {
    render() {
        const props = this.props;
        return (
            <div className="backgroundContent">
                <div className="row commandRow">
                    <ToolTitle
                        title={t("common.preview")}
                    />
                </div>
                <DocumentPreview
                    file={props.file}
                    fileName={props.fileName}
                    fileMimeType={props.fileMimeType}
                    thumbnails={props.thumbnails}
                    thumbnailIndex={props.thumbnailIndex}
                />
            </div>
        );
    }
}